<template>
  <div v-show="isVisible" :class="componentClassName">
    <div :class="`a-calling-action-button__body ${tooltip && dataTooltip ? 'a-calling-action-button__tooltip' : ''}`">
      <a-button
        :id="id"
        class="a-calling-action-button__button"
        :data-tooltip="dataTooltip"
        :variant="buttonType"
        :icon="icon"
        :icon-color="buttonIconColor"
        :color="buttonColor"
        :label="buttonLabel"
        :disabled="disabled ? 'disabled' : null"
        @click="handleActionButtonClick"
      />
      <span v-if="variant === null">{{ label }}</span>
    </div>
    <div v-show="popup" class="a-calling-action-button__popup">
      <slot name="popup"></slot>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';

export default {
  name: 'a-calling-action-button',
  components: {
    AButton,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    isVisible: {
      type: Boolean,
      default: true,
    },
    variant: {
      type: String,
      default: null,
      validator(value) {
        return value.match(/(round)/) || value === null;
      },
    },
    popupPosition: {
      type: String,
      default: 'top',
      validator(value) {
        return value.match(/(top|bottom)/);
      },
    },
    id: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    activated: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    popup: {
      type: Boolean,
      default: false,
    },
    handleActionButtonClick: {
      type: Function,
      default: () => {},
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    dataTooltip: {
      type: String,
      default: '',
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-calling-action-button', this.popup ? `popup-${this.popupPosition}` : '');
      return `${baseClassName} ${this.class}`.trim();
    },
    buttonIconColor() {
      return this.activated ? 'white' : 'orange';
    },
    buttonColor() {
      return this.activated ? 'primary' : 'white';
    },
    buttonType() {
      return this.variant === 'round' ? 'round' : 'icon';
    },
    buttonLabel() {
      return this.variant === 'round' ? this.label : null;
    },
  },
};
</script>
